const swissmedical = require('./swissmedical.json');
const omint = require('./omint.json');
const patagonia = require('./patagonia.json');
const activo = require('./activo.json');
const heineken = require('./heineken.json');
const walmart = require('./walmart.json');
const simplicity = require('./simplicity.json')
const farmaciasdelahorro = require('./farmacias-del-ahorro.json')
const alsea = require('./alsea.json')
const danone = require('./danone.json')
const vips = require('./vips.json')
const burgerking = require('./burgerKing.json')
const thecheesecakefactory = require('./cheeseCakeFactory.json')
const italiannis = require('./italianis.json')
const chilis = require('./chilis.json')
const chipotle = require('./chipotle.json')
const dominos = require('./dominos.json')
const pfchangs = require('./pfchangs.json')
const starbucks = require('./starbucks.json')
const nemak = require('./nemak.json')
const demo = require('./demo.json')
const gardaworld = require('./garda.json')
const oxxo = require('./oxxo.json')
const dish = require('./dish.json')
const demoUs = require('./demoUs.json')
const honeyBadger = require('./honeyBadger.json')
const hiltonDemo = require('./hiltonDemo.json')
const centrodeoperacionesalsea = require('./centrodeoperacionesalsea.json')
const thehomedepot = require('./thehomedepot.json')
const oxxocedis = require('./oxxocedis.json')
const bodesa = require('./bodesa.json')
const kfc = require('./kfc')
const ihop = require('./ihop')
const carlsjr = require('./carlsjr')
const buffaloWildWings = require('./buffaloWildWings')
const mercadolibre = require('./mercadolibre.json')
const vivaaerobus = require('./vivaaerobus.json')
const oxxogas = require('./oxxogas.json')
const gruporoga = require('./gruporoga.json')
const liverpool = require('./liverpool.json');
const liverpool1 = require('./liverpool1.json');
const liverpool2 = require('./liverpool2.json');
const liverpool3 = require('./liverpool3.json');
const liverpool4 = require('./liverpool4.json');
const uvc = require('./uvc.json');
const thehomedepotcedis = require('./thehomedepotcedis.json');
const mecanicatek = require('./mecanicatek.json');
const mercadolibre2 = require('./mercadolibre2.json');
const arcacontinental = require('./arcacontinental.json');
const bepensabebidas = require('./bepensabebidas.json');
const mercadolibreambienteprueba = require('./mercadolibreambienteprueba.json');
const mercadolivreambientedeteste = require('./mercadolivreambientedeteste.json');
const mercadolivre = require('./mercadolivre.json');
const omnisource = require('./omnisource.json');
const medicosfarmaciasdelahorro = require('./medicos-farmacias-del-ahorro.json');
const gepp = require('./gepp.json');
const pizzahut = require('./pizzahut.json');
const cocacolafemsa = require('./cocaColaFemsa.json');
const cinemex = require('./cinemex.json');
const kohler = require('./kohler.json');
const nicxa = require('./nicxa.json');
const jumex = require('./jumex.json');
const donatota = require('./donatota.json');
const grupocampomar = require('./grupocampomar.json');
const tiendasbara = require('./tiendasbara.json');
const avaresort = require('./avaresort.json');
const farmaciasdelahorrocedis = require('./farmaciasdelahorrocedis.json');
const farmaciasroma = require('./farmacias-roma.json');
const caffenio = require('./caffenio.json');
const cima = require('./cima.json');
const felz = require('./felz.json');


// these keys are the endpoint and will load the corresponding file
module.exports = {
  swissmedical,
  omint,
  patagonia,
  activo,
  heineken,
  walmart,
  simplicity,
  farmaciasdelahorro,
  alsea,
  danone,
  vips,
  burgerking,
  thecheesecakefactory,
  italiannis,
  chilis,
  chipotle,
  dominos,
  pfchangs,
  starbucks,
  nemak,
  gardaworld,
  demo,
  oxxo,
  dish,
  demoUs,
  honeyBadger,
  hiltonDemo,
  centrodeoperacionesalsea,
  thehomedepot,
  oxxocedis,
  bodesa,
  kfc,
  ihop,
  carlsjr,
  buffaloWildWings,
  mercadolibre,
  vivaaerobus,
  oxxogas,
  gruporoga,
  liverpool,
  liverpool1,
  liverpool2,
  liverpool3,
  liverpool4,
  uvc,
  thehomedepotcedis,
  mecanicatek,
  mercadolibre2,
  arcacontinental,
  bepensabebidas,
  mercadolibreambienteprueba,
  mercadolivreambientedeteste,
  mercadolivre,
  omnisource,
  medicosfarmaciasdelahorro,
  gepp,
  pizzahut,
  cocacolafemsa,
  cinemex,
  kohler,
  nicxa,
  jumex,
  donatota,
  grupocampomar,
  tiendasbara,
  avaresort,
  farmaciasdelahorrocedis,
  farmaciasroma,
  caffenio,
  cima,
  felz
};
